import DOMPurify from "dompurify";

function SanitizeHtml({ filterText = "" }) {
  return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(filterText) }} />;
}

export default SanitizeHtml;
